import { SimpleForm, FileInput, FileField, required, useNotify } from "react-admin";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DocumentFilesArray from "./DocumentFilesArray";
import BackButtonToolbar from "features/BackButtonToolbar";
import { documentRequests } from "api/documentsApi";
import { useNotifyError } from "utils/useNotifyError";

const EditDocumentForm = () => {
  const notifyError = useNotifyError();
  const notify = useNotify();

  const { id } = useParams();
  const [filesData, setFilesData] = useState([]);

  useEffect(() => {
    const fetchDocument = async () => {
      if (!id) {
        return;
      }

      try {
        const { data } = await dataProvider.customRequest(documentRequests.getDeclarationById(id), null, "GET");

        setFilesData(data);
      } catch (e) {
        notifyError(e);
        setFilesData([]);
      }
    };

    fetchDocument();
  }, [id, notifyError]);

  const customSubmit = async data => {
    data.files = [];

    try {
      await dataProvider.customRequest(documentRequests.updateDeclaration(id), data, "PUT", null, true);
      notify("Успешно добавяне на файлове", { type: "success" });
      window.location.reload();
    } catch (err) {
      notifyError(err);
    }
  };

  const validateFileType = value => {
    if (!value) return "Файлът е задължителен.";

    const fileSrc = value?.rawFile?.name || value?.src?.toLowerCase?.();

    const allowedExtensions = [".jpeg", ".jpg", ".png", ".pdf"];

    if (!fileSrc) return "Файлът е невалиден.";

    const hasValidExtension = allowedExtensions.some(ext => fileSrc.endsWith(ext));
    if (!hasValidExtension) {
      return "Разрешени са само файлове с разширения .jpeg, .jpg, .png или .pdf.";
    }

    return undefined;
  };

  return (
    <>
      <BackButtonToolbar />
      <DocumentFilesArray
        filesData={filesData}
        notify={notify}
      />
      <SimpleForm onSubmit={customSubmit}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={4.5}
          >
            <FileInput
              source="bgFile"
              label="Файл на български език"
              validate={(required(), validateFileType)}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={4.5}
          >
            <FileInput
              source="enFile"
              label="Файл на английски език"
              validate={(required(), validateFileType)}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            sx={{ marginTop: 4 }}
          >
            <CustomDateInput
              label="Валиден от"
              source="validFrom"
              validate={required("Задължително")}
              required={true}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </>
  );
};

export default EditDocumentForm;
